import React, { useCallback, useEffect, useState } from 'react';
import ButtonNew from 'components/inputs/ButtonNew';
import classNames from 'classnames';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { removeMatrix } from 'actions/matrices';

const Button = ({
  onClick,
  kind = 'next',
  className,
  label,
  steps,
  stepsLength,
  currentStep,
  disableAll,
  setIsOpen,
  setCurrentStep,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  let [tourExperimentId, setTourExperimentId] = useState(null);

  const clickHandler = useCallback(() => {
    const { storeExperimentId, deleteExperiment } = steps[currentStep];
    if (!disableAll) {
      if (onClick && typeof onClick === 'function') {
        onClick();
      } else {
        if (kind === 'next') {
          if (storeExperimentId) {
            const experimentId = history?.location?.pathname
              ?.split('experiments/')?.[1]
              ?.split('/')?.[0];
            if (experimentId) {
              setTourExperimentId(experimentId);
            }
          }

          if (currentStep === stepsLength - 1) {
            if (deleteExperiment && tourExperimentId) {
              dispatch(removeMatrix(tourExperimentId));
            }
            setIsOpen(false);
          } else {
            setCurrentStep(Math.min(currentStep + 1, stepsLength - 1));
          }
        } else {
          setCurrentStep(Math.max(currentStep - 1, 0));
        }
      }
    }
  }, [
    currentStep,
    disableAll,
    onClick,
    dispatch,
    history,
    kind,
    setCurrentStep,
    steps,
    stepsLength,
    setIsOpen,
    tourExperimentId,
  ]);

  return (
    <ButtonNew
      buttonClasses={classNames(kind, className, {
        disabled: disableAll
          ? disableAll
          : kind === 'next'
          ? stepsLength === currentStep
          : currentStep === 0,
      })}
      onClick={clickHandler}
      aria-label={`Go to ${kind} step`}
      label={label}
    ></ButtonNew>
  );
};

//Component for # of steps and prev/next buttons
export const TourNavigationComponent = ({
  steps,
  setCurrentStep,
  currentStep,
  setIsOpen,
  nextButton,
  hideButtons,
  disableAll,
}) => {
  const stepsLength = steps.length;

  return (
    <div className="Popover-navigation">
      <div className="step-indicator">
        Step {currentStep + 1} of {steps.length}
      </div>
      <div className="action-buttons">
        {/* Removing "previous" for now for ease since tour steps are coded for complex actions that don't work in reverse */}
        {/* <div>
          {!hideButtons ? (
            currentStep !== 0 ? (
              <Button
                className="secondary-button-dark-small"
                kind="prev"
                label="Previous"
              ></Button>
            ) : null
          ) : null}
        </div> */}
        <div>
          {!hideButtons ? (
            nextButton && typeof nextButton === 'function' ? (
              nextButton({
                Button,
                setCurrentStep,
                currentStep,
                stepsLength,
                setIsOpen,
              })
            ) : (
              <Button
                className="primary-button-small"
                kind="next"
                label={currentStep === steps.length - 1 ? 'Finish' : 'Next'}
                steps={steps}
                stepsLength={stepsLength}
                currentStep={currentStep}
                disableAll={disableAll}
                setIsOpen={setIsOpen}
                setCurrentStep={setCurrentStep}
              ></Button>
            )
          ) : null}
        </div>
      </div>
    </div>
  );
};
